// @ts-check
import { nextArrow, prevArrow, options } from "../global/slick-options";

jQuery(function ($) {
  document.querySelectorAll(".slideroo--small").forEach((slider) => {
    $(slider).slick({
      ...options,
      slidesToShow: 4,
      nextArrow,
      prevArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});

jQuery(function ($) {
  document.querySelectorAll(".slideroo--medium").forEach((slider) => {
    $(slider).slick({
      ...options,
      slidesToShow: 2,
      nextArrow,
      prevArrow,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});

jQuery(function ($) {
  document.querySelectorAll(".slideroo--large").forEach((slider) => {
    $(slider).slick({
      ...options,
      slidesToShow: 1.33,
      nextArrow,
      prevArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});

jQuery(function ($) {
  document.querySelectorAll(".slideroo--huge").forEach((slider) => {
    $(slider).slick({
      ...options,
      slidesToShow: 1,
      nextArrow,
      prevArrow,
    });
  });
});

jQuery(function ($) {
  document.querySelectorAll(".slideroo--staggered").forEach((slider) => {
    $(slider).slick({
      ...options,
      slidesToShow: 1,
      dots: true,
      fade: true,
    });
  });
});

jQuery(function ($) {
  document.querySelectorAll(".slideroo--gallery").forEach((slider) => {
    $(slider).slick({
      ...options,
      slidesToShow: 1,
      nextArrow,
      prevArrow,
    });
  });
});
